<template>
  <div>
    <footer-button class="header-button" type="Edit"
                   label-break-point="sm"
                   v-if="saveEditMode === 'EDIT' || saveEditMode === true"
                   :disabled="!editEnabled"
                   @edit="clickEdit"
                   ref="btn"
                   :data-test-path="form ? 'form-header-edit' + '-' + form.formTitle : 'edit-button'"
    ></footer-button>
    <footer-button class="header-button" type="Save" label-break-point="sm"
                   v-if="saveEditMode === 'SAVE'  || saveEditMode === false"
                   :disabled="!saveEnabled"
                   @save="clickSave"
    ></footer-button>
  </div>
</template>

<script>

import FooterButton from "@/components/navbar/FooterButton";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";

export default {
  name: "EditSaveButton",
  components: {FooterButton},
  props: {
    saveEditMode: {default: "EDIT"},
    editEnabled: {default: true},
    saveEnabled: {default: true},
    form: {type: BaseFormConfig, default: null}
  },
  methods: {
    clickSave() {
      this.$emit("save");
    },
    clickEdit() {
      this.$emit("edit");
    },
    focus() {
      if (this.$refs.btn?.$refs?.button) {
        this.$refs.btn.$refs.button.focus();
      }
    },
  }
}
</script>

<style scoped>

</style>